import { TABLE_WIDGET, Widget, BaseFieldWidget, ActiveRecordsOperator, ActiveRecords, DeleteActiveRecordsByEntityPredict, FormO2MTableFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import { nextTick } from 'vue';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: 'deli.retail.BackendRetailItem',
    viewName: '商品表单-复制_FORM_uiViewfe64c05db70140fcac27237fb96578fe',
    name: 'itemSkus',
    viewType: ViewType.Form,
    ttype: [ModelFieldType.OneToMany],
    widget: TABLE_WIDGET
  })
)
export class RetailItemFormO2MTableFieldWidget extends FormO2MTableFieldWidget {

    @Widget.Method()
    @Widget.Provide()
    public deleteDataSourceByEntity(records: ActiveRecords, predict?: DeleteActiveRecordsByEntityPredict) {
        if (this.parentDeleteDataSourceByEntity && this.getCurrentDataSource() === undefined) {
            this.parentDeleteDataSourceByEntity(records, predict);
        } else {
            const nextDataSource = ActiveRecordsOperator.operator(this.getCurrentDataSource() || undefined, this.submitCache)
              .deleteByEntity(records, predict)
              .get();

            // 全表编辑的表格，新增或删除数据行时，需要先清空再赋值，否则页面现有的编辑态数据无法更新
            this.setCurrentDataSource([]);
            this.flushDataSource();
            nextTick(() => {
                this.setCurrentDataSource(nextDataSource);
                this.flushDataSource();
            });
        }
    }
}
